import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=6452f9e4&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6452f9e4')) {
      api.createRecord('6452f9e4', component.options)
    } else {
      api.reload('6452f9e4', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=6452f9e4&", function () {
      api.rerender('6452f9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/AppMain.vue"
export default component.exports